import { z } from 'zod'
import { Plan, UnitsPreference } from '../enums'
import { Id, Timestamp } from './common'

export const Me = z.object({
  id: Id,
  email: z.string(),
  units: UnitsPreference,
  plan: Plan,
  created_at: Timestamp,
  /**
   * Said "I'll stick with passwords": no device offers a passkey. Defaults
   * to false so a profile cached before passkeys still reads.
   */
  passkeys_declined: z.boolean().default(false),
})
export type Me = z.infer<typeof Me>

export const UpdateMeBody = z
  .object({ units: UnitsPreference })
  .partial()
  .refine((b) => Object.keys(b).length > 0, 'Nothing to update.')
export type UpdateMeBody = z.infer<typeof UpdateMeBody>

export const CreateApiKeyBody = z.object({ label: z.string().trim().min(1).max(80) })
export type CreateApiKeyBody = z.infer<typeof CreateApiKeyBody>

export const ApiKey = z.object({
  id: Id,
  key_id: z.string(),
  label: z.string(),
  created_at: Timestamp,
  last_used_at: Timestamp.nullable(),
  revoked_at: Timestamp.nullable(),
})
export type ApiKey = z.infer<typeof ApiKey>

/** Returned once, at creation. The secret is never retrievable again. */
export const CreatedApiKey = ApiKey.extend({ secret: z.string() })
export type CreatedApiKey = z.infer<typeof CreatedApiKey>
